import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DialogService } from 'app/services/dialog.service';
import { IconService } from 'app/services/icon.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { ProjectIconSelectorDialogComponent } from '../project-icon-selector/project-icon-selector.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-project-icon',
  templateUrl: './project-icon.component.html',
  styleUrls: ['./project-icon.component.scss'],
  standalone: false,
})
export class ProjectIconComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() iconUrl: string;
  @Input() isReadOnly: boolean;
  @Input() isAdmin: boolean;

  @Output() iconUrlChange = new EventEmitter<string>();
  projectIcon: string;
  constructor(
    private dialogService: DialogService,
    public iconService: IconService
  ) {}

  ngOnInit(): void {
    this.projectIcon = this.iconService.getProjectIcon(this.iconUrl);
  }

  public selectIconDialog(): void {
    this.dialogService
      .showDialog<ProjectIconSelectorDialogComponent>(
        ProjectIconSelectorDialogComponent,
        this.iconUrl,
        {
          width: '512px',
          autoFocus: false,
        }
      )
      .afterClosed()
      .subscribe((response) => {
        this.projectIcon = this.iconService.getProjectIcon(response.iconUrl);
        this.iconUrlChange.emit(response.iconUrl);
      });
  }

  onRemoveProjectIcon() {
    this.projectIcon = '';
    this.iconUrlChange.emit('');
  }
}
